import { IMPORT_BASE } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export type ImportHubItemPayload = {
  importKey: string;
};

export interface HubImportResponse {
  data: string | null;
  message: string;
  success: boolean;
}

const importHubItem = (
  body: ImportHubItemPayload,
): Promise<HubImportResponse> => {
  return mutationFetch<HubImportResponse>({
    url: IMPORT_BASE,
    method: "POST",
    body,
  });
};

export const useImportHubItem = (
  options?: UseMutationOptions<
    HubImportResponse,
    AxiosError,
    ImportHubItemPayload
  >,
) => {
  return useMutation({
    mutationFn: importHubItem,
    ...options,
  });
};
